import React, {useState} from 'react';
import './startBusiness.scss';
import {Button, CourseCard} from 'components';
import START_IMAGE1 from 'assets/dashboard/starting_image.svg';
import {CourseCardProps} from "../../../../components/course-card/CourseCard";

const StartBusiness = () => {

    const [courses] = useState<CourseCardProps[]>([
        {
            image: START_IMAGE1,
            heading: "Business Registration Process",
            description: "What better way to increase your knowledge than. What better way to increase your knowledge than.",
            isDone: false,
            link: "test"
        },
        {
            image: START_IMAGE1,
            heading: "Business Tax Registration Process",
            description: "What better way to increase your knowledge than. What better way to increase your knowledge than.",
            isDone: true,
            link: "test"
        },
        {
            image: START_IMAGE1,
            heading: "Business Marketing",
            description: "What better way to increase your knowledge than. What better way to increase your knowledge than.",
            isDone: false,
            link: "test"
        },
        {
            image: START_IMAGE1,
            heading: "Business Finance",
            description: "What better way to increase your knowledge than. What better way to increase your knowledge than.",
            isDone: false,
            link: "test"
        },
        {
            image: START_IMAGE1,
            heading: "Business Accounting",
            description: "What better way to increase your knowledge than. What better way to increase your knowledge than.",
            isDone: true,
            link: "test"
        },
        {
            image: START_IMAGE1,
            heading: "Product Development & Distribution",
            description: "What better way to increase your knowledge than. What better way to increase your knowledge than.",
            isDone: false,
            link: "test"
        },
    ])
    return (
        <div className={'start-business'}>
            <div className={'start-business_header'}>
                <div className={'start-business_header_left'}>
                    <h1>Start Business</h1>
                    <p>Planning a business has never been easier. With our help, you can smoothly transition through the
                        planning stages in order to get your business started. <br/><br/>Get started by going through
                        the
                        available courses below.</p>
                    <Button text={'Schedule A Meeting'} type='primary'/>
                </div>
                <div className={'start-business_header_right'}>
                    <img src={START_IMAGE1} alt=""/>
                </div>
            </div>
            <div className={'start-business_courses'}>
                <div className={'start-business_courses_top'}>
                    <h1>Courses</h1>
                </div>
                <div className={'start-business_courses_bottom'}>
                    {courses.map(({image, heading, description, isDone, link}) => (
                        <CourseCard image={image} heading={heading} description={description} isDone={isDone}
                                    link={link}/>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StartBusiness;